import React from "react";

const COPIES = ["copy-a", "copy-b"];

export default function Marquee() {
  return (
    <div className="marquee" aria-hidden>
      <div className="marquee__track">
        {COPIES.map((copyId) => (
          <React.Fragment key={copyId}>
            <span>This book is not copyrighted.</span>
            <span>·</span>
            <span>Reproduce it in whole or in part.</span>
            <span>·</span>
            <span>Translate it. Print it. Mail it.</span>
            <span>·</span>
            <span>Be the hundredth monkey.</span>
            <span>·</span>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
